const { timeAgo, epochToClock } = require('./timeAgo.js')
const albumView = require('./ui.albumView.js')
const app = require('./app.js')

class ImagePlayer {
    constructor(frameData = [], data, onclose, displayTime = 1000) {
        this.data = data
        this.frames = frameData
        this.windowClosed = false
        this.id = data ? data.id : 0
        console.log('id', this.id)
        this.onclose = onclose
        this.container = this.createContainer(data)
        this.isLive(data.isLive)
        this.thumbnail = this.container.querySelector('.cast_thumbnail')
        this.progressBar = this.container.querySelector('.progress')
        this.bufferBar = this.container.querySelector('.buffered')
        this.centerPlayPauseButton = this.container.querySelector('.center_play_pause')
        this.title = this.container.querySelector('.titleTxt')
        this.setTitle(data)
        this.closeButton = this.container.querySelector('.close_button')
        // this.toolbarPlayButton = this.container.querySelector('.toolbar_play_button')
        this.currentTimeLabel = this.container.querySelector('.current_time')
        this.totalTimeLabel = this.container.querySelector('.total_time')
        this.appNameLabel = this.container.querySelector('.appName')
        this.viewportMetaTag = document.querySelector('meta[name="viewport"]')
        this.bookmarkButton = this.container.querySelector('.bookmark_button i')
        this.clock = this.container.querySelector('.clock')
        this.images = []
        this.currentIndex = 0
        this.displayTime = displayTime
        this.playInterval = null
        this.listeners = {
            play: [],
            pause: [],
            finish: [],
        }
        this.isDragging = false
        this.touchStartX = 0
        this.touchEndX = 0
        this.appsStartingFrame = []

        // Initialize
        this.initTooltip()
        this.initializeEventListeners()
        if (frames.length) this.addFrames(frameData)
        // this.hideButtonOnInactivity()
        this.disableUserScaling()
        var details = navigator.userAgent
        var regexp = /android/i
        var isMobileDevice = regexp.test(details)
        if (isMobileDevice && window.screen.height !== window.screen.availHeight) {
            this.container.querySelector('.cast_controls').classList.add('position-fix')
        }
        if (data && data.bookmarked) this.bookmarkButton.classList.add('icon-bookmark-full')
        else this.bookmarkButton.classList.add('icon-bookmark')
        app.data.get({ type: 'device', identifier: this.data.device_id }, (data) => {
            this.device = data
        })
        setTimeout(() => {
            this.centerPlayPauseButton.click()
        }, 666)
    }

    createContainer(data) {
        const container = document.createElement('div')
        container.setAttribute('class', 'cast_container active animate zoomIn')
        container.innerHTML = document.getElementById('imagePlayer').innerHTML
        document.body.appendChild(container)
        container.querySelector('img').src = data.thumbnail
        return container
    }

    // creatPaymentDummy() {
    //     const container = document.querySelector('.cast_container')
    //     const containerPayment = document.createElement('div')
    //     this.paymentBackground.setAttribute('class', 'payment__background')
    //     containerPayment.setAttribute('class', 'payment')
    //     containerPayment.innerHTML = `
    //         <div class="payment__block">
    //             <div class="payment__block__header">Unlock Your Timeline</div>
    //             <div class="payment__block__text first-screen">Stay informed with uninterrupted insights and updates. Subscribe now for complete access to your monitoring timeline.</div>
    //             <div class="payment__block__btn">VIEW SUBSCRIPTION DETAILS</div>
    //         </div>
    //     `
    //     container.appendChild(containerPayment)
    //     container.appendChild(this.paymentBackground)
    //
    //     document.querySelector('.payment__block__btn').addEventListener('click', () => {
    //         document.querySelector('.payment').remove()
    //         this.showPaymentsPlan()
    //     })
    // }
    showPaymentsPlan() {
        const container = document.querySelector('.cast_container')
        const containerPlans = document.createElement('div')
        containerPlans.setAttribute('class', 'payment-plans')
        containerPlans.innerHTML = ui.pricings.pricingHtml
        container.appendChild(containerPlans)

        var planList = document.querySelectorAll('.payment-plans__item')
        let selectedPlan
        planList.forEach((e) => {
            e.addEventListener('click', () => {
                planList.forEach((e) => {
                    e.classList.remove('payment-plans__item--selected')
                })
                e.classList.add('payment-plans__item--selected')
                selectedPlan = e.dataset.plan
            })
        })
        document.querySelector('.payment__block__button').addEventListener('click', () => {
            this.creatPaymentUrl(selectedPlan, 'paypal')
        })
        document.querySelector('.payment__block__button--credit').addEventListener('click', () => {
            this.creatPaymentUrl(selectedPlan, 'credit')
        })
        var popUpTimer
        clearTimeout(popUpTimer)
        document.querySelector('.payment__block__close').addEventListener('click', () => {
            this.thumbnail.style.display = 'block'
            document.querySelector('.payment-plans').classList.add('slideOut')
            setTimeout(() => {
                document.querySelector('.payment-plans').remove()
            }, 800)
            this.centerPlayPauseButton.style.opacity = '1'
            this.windowClosed = true
            popUpTimer = setTimeout(() => {
                this.thumbnail.style.display = 'none'
                this.showPaymentsPlan()
            }, 5000)
        })
    }

    creatPaymentUrl(plan, btnClicked) {
        this.GetPaymentToken()
            .then((put_token) => {
                if (!plan) {
                    plan = 'mdm_y_182_00'
                }
                let pprov = 'paypal'
                if (btnClicked.includes('credit')) {
                    pprov = 'stripe'
                }
                if (typeof gtag === 'function') {
                    console.log('Gtag for pay ', 'to_pay_' + pprov, {
                        amount: plan
                            .replace(/t3_|t2_|mdm_/, '')
                            .replace(/[a-z]_/, '')
                            .replace('_', '.'),
                    })
                    //gtag('event', 'to_pay_' + btnClicked + '_' + plan.replace(/t3_|t2_|mdm_/, ''))
                    gtag('event', 'to_pay_' + pprov, {
                        amount: plan
                            .replace(/t3_|t2_|mdm_/, '')
                            .replace(/[a-z]_/, '')
                            .replace('_', '.'),
                    })
                } else {
                    console.log('No Gtag')
                }
                if (put_token && btnClicked === 'paypal') {
                    window.location.href = `https://pay.livescreenapp.com/plugin/firebase_login/?at=${encodeURIComponent(put_token)}&did=${encodeURIComponent(this.data.device_id)}&sku=${encodeURIComponent(plan)}&returnUrl=${encodeURIComponent(location.href)}`
                } else if (put_token && btnClicked === 'credit') {
                    window.location.href = `https://pay.livescreenapp.com/plugin/firebase_login/?at=${encodeURIComponent(put_token)}&did=${encodeURIComponent(this.data.device_id)}&pmgw=stripe&sku=${encodeURIComponent(plan)}&returnUrl=${encodeURIComponent(location.href)}`
                }
            })
            .catch((e) => {
                console.log(e)
            })
    }

    async GetPaymentToken() {
        let pt = this.parsePutToken()
        console.log('payment-token before:', pt)
        if (pt) {
            return pt
        }
        const resp = await fetch(`https://caapi.livescreenapp.com/api/get-payment-token`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                Accept: 'application/json',
            },
        }).then((r) => {
            if (!(r.ok || r.status === 200)) {
                throw new Error('handle no put token')
            }
        })
        pt = this.parsePutToken()
        console.log('payment-token:', pt)
        return pt
    }
    parsePutToken() {
        return document.cookie
            .split('; ')
            .find((row) => row.startsWith('put_token='))
            ?.split('=')[1]
    }
    initTooltip() {
        this.tooltip = document.createElement('span')
        this.tooltip.classList.add('tooltip')
        this.progressBar.parentElement.appendChild(this.tooltip)
        this.tooltip.style.display = 'none'
    }

    initializeEventListeners() {
        this.centerPlayPauseButton.addEventListener('click', () => this.togglePlayPause())
        // this.toolbarPlayButton.addEventListener('click', () => this.togglePlayPause())
        this.thumbnail.addEventListener('click', () => this.togglePlayPause())
        this.closeButton.addEventListener('click', () => this.hide())
        this.progressBar.parentElement.addEventListener('mousemove', (e) => this.showTimeTooltip(e))
        this.progressBar.parentElement.addEventListener('click', (e) => this.seek(e))
        this.dragBound = this.drag.bind(this)
        this.stopDragBound = this.stopDrag.bind(this)
        this.progressBar.parentElement.addEventListener('mousedown', (e) => this.startDrag(e))
        this.progressBar.parentElement.addEventListener('mouseout', () => (this.tooltip.style.display = 'none'))
        this.clock.onclick = () => {
            this.showAlbumView()
        }

        // Touch events for mobile
        this.progressBar.parentElement.addEventListener('touchstart', (e) => this.startDrag(e.touches[0]))
        this.progressBar.parentElement.addEventListener('touchmove', (e) => {
            e.preventDefault()
            this.drag(e.touches[0])
        })
        this.progressBar.parentElement.addEventListener('touchend', () => this.stopDrag())

        this.keydownHandler = this.handleKeydown.bind(this) // bind this to ensure context
        document.addEventListener('keydown', this.keydownHandler)

        this.initializeZoomEventListeners()

        this.appNameLabel.parentElement.addEventListener('click', () => {
            this.toggleAppsTimeline()
        })

        this.bookmarkButton.addEventListener('click', () => {
            this.toggleBookmark()
        })
    }

    toggleBookmark() {
        if (this.bookmarkButton.classList.contains('icon-bookmark-full')) {
            this.bookmarkButton.classList.remove('icon-bookmark-full')
            this.bookmarkButton.classList.add('icon-bookmark')
            app.webSocket.sendMessage({ type: 'unbookmarkCast', id: this.id })
        } else {
            this.bookmarkButton.classList.add('icon-bookmark-full')
            this.bookmarkButton.classList.remove('icon-bookmark')
            app.webSocket.sendMessage({ type: 'bookmarkCast', id: this.id })
        }
    }

    toggleAppsTimeline() {
        if (this.container.classList.contains('showAppsTimeline')) {
            this.container.classList.remove('showAppsTimeline')
        } else {
            this.container.classList.add('showAppsTimeline')
        }
    }

    hideButtonOnInactivity() {
        this.container.addEventListener('mousemove', () => {
            this.container.classList.add('active')
            clearTimeout(this.hideButtonTimeout)
            this.hideButtonTimeout = setTimeout(() => {
                if (!this.isPaused()) {
                    this.container.classList.remove('active')
                }
            }, 1100)
        })
    }

    loadSingleImage(frame) {
        return new Promise((resolve, reject) => {
            let img = new Image()
            // img.onload = () => resolve(img);
            img.onerror = () => {
                console.warn(`Failed to load image: ${frame.url}`)
                //resolve(null);
            }
            img.src = frame.url
            img.dataset.clock = frame.time ? epochToClock(frame.time) : ''
            resolve(img)
        })
    }

    extractAppData(frame) {
        if (frame.app && frame.app.package) {
            // Check if the app exists in the last frame processed
            const lastApp = this.appsStartingFrame[this.appsStartingFrame.length - 1]
            if (!lastApp || lastApp.package !== frame.app.package) {
                const app = {
                    name: frame.app.name,
                    package: frame.app.package,
                    icon: frame.app.icon,
                    startingFrame: this.images.length,
                }
                this.appsStartingFrame.push(app)

                const div = document.createElement('div')
                const icon = frame.app.icon
                const defaultIcon = './android.robot.jpeg'
                const frameTime = this.formatTime(this.images.length * this.displayTime - this.displayTime)
                div.classList.add('app_item')
                div.setAttribute('title', frame.app.name)
                div.id = 'frame' + this.images.length
                div.innerHTML = `<span class="app_name"><img src="${icon}" onerror="this.src='${defaultIcon}'" alt="${frame.app.name}"></span>` + `<span class="app_time">${frameTime}</span>`
                const playFrom = this.images.length - 1
                div.addEventListener('click', () => {
                    const wasPlaying = !this.isPaused()
                    this.pause(false) // Pause it first
                    this.currentIndex = playFrom - 1
                    this.displayImage(this.images[this.currentIndex])
                    this.updatePlayTime()
                    if (wasPlaying) {
                        this.play()
                    }
                    this.displayAppName(app, true)
                })
                this.container.querySelector('.apps_timeline').appendChild(div)

                if (this.images.length <= 1) {
                    this.displayAppName(frame.app)
                }
            }
        }
    }

    addFrames(frameData) {
        if (!this.images.length) this.updateTotalTime(frameData.length)
        const loadPromises = frameData.map((frame) =>
            this.loadSingleImage(frame).then((img) => {
                if (img) {
                    this.images.push(img)
                    this.updateBufferBar(frameData.length)
                    this.extractAppData(frame)
                }
                return img
            })
        )

        // Once all images are loaded or failed to load
        Promise.all(loadPromises).then(() => {
            this.updateTotalTime() // Update the total time label
        })

        if (this.getCurrentTime() > 1 && this.isLive()) {
            this.play()
        }

        if (this.albumView) this.albumView.addFrames(frameData)
        this.frames.push(...frameData)
    }

    updateTotalTime(frameLength = 0) {
        console.log('updateTotalTime', frameLength)
        this.totalTimeLabel.textContent = this.formatTime((frameLength || this.images.length) * this.displayTime)
    }

    updateBufferBar(numOfFrames) {
        var loadedPercentage = (this.images.length / numOfFrames) * 100
        if (loadedPercentage > 100) loadedPercentage = 100
        this.bufferBar.style.width = `${loadedPercentage}%`
    }

    showTimeTooltip(event) {
        const rect = this.progressBar.parentElement.getBoundingClientRect()
        const hoverPosition = event.clientX - rect.left
        const hoverPercentage = hoverPosition / rect.width
        const hoverTime = Math.floor(hoverPercentage * this.images.length) * this.displayTime
        this.tooltip.textContent = this.formatTime(hoverTime)
        this.tooltip.style.left = `${hoverPosition}px`
        this.tooltip.style.display = 'block'
    }

    startDrag(event) {
        this.isDragging = true
        this.seek(event) // Immediately update the position when starting the drag

        // Add mousemove and mouseup event listeners to the document
        document.addEventListener('mousemove', this.dragBound)
        document.addEventListener('mouseup', this.stopDragBound)
    }

    drag(event) {
        if (this.isDragging) {
            this.seek(event)
        }
    }

    stopDrag(event) {
        if (this.isDragging) {
            this.seek(event)
            this.isDragging = false

            // Remove mousemove and mouseup event listeners from the document
            document.removeEventListener('mousemove', this.dragBound)
            document.removeEventListener('mouseup', this.stopDragBound)
        }
    }

    isPaused() {
        return !this.playInterval
    }

    togglePlayPause() {
        if (this.isPaused()) {
            if (this.currentIndex === this.images.length) {
                this.currentIndex = 0 // Reset to the start if at the end
            }
            this.centerPlayPauseButton.innerHTML = '<i class="material-icons">pause</i>' // Update icon to Pause
            // this.toolbarPlayButton.innerHTML = '<i class="material-icons">pause</i>' // Update icon to Pause
            this.play()
        } else {
            this.centerPlayPauseButton.innerHTML = '<i class="material-icons">play_arrow</i>' // Update icon to Play
            // this.toolbarPlayButton.innerHTML = '<i class="material-icons">play_arrow</i>' // Update icon to Play
            this.pause()
        }
    }

    displayImage(img) {
        if (img && img.src) {
            this.thumbnail.src = img.src
            this.clock.innerHTML = img.dataset.clock
        }
    }

    updatePlayTime() {
        this.currentTimeLabel.textContent = this.formatTime(this.getCurrentTime())
        this.totalTimeLabel.textContent = this.formatTime(this.images.length * this.displayTime)

        if (this.device.subState !== 'pending' && this.device.subState !== 'approved' && this.device.subState !== 'canceled') {
            if (document.querySelector('.payment-plans') && this.getCurrentTime() >= 3000) {
                return
            }
            if (!document.querySelector('.payment-plans') && this.getCurrentTime() >= 3000 && !this.windowClosed) {
                this.showPaymentsPlan()
                this.thumbnail.style.display = 'none'
                this.centerPlayPauseButton.style.opacity = '0'
            }
        }

        var playPercentage = this.getPlayPercentage() * 100
        if (playPercentage > 100) playPercentage = 100
        this.progressBar.style.width = `${playPercentage}%`
    }

    formatTime(milliseconds) {
        if (isNaN(milliseconds) || milliseconds < 0) return '00:00'
        const totalSeconds = Math.floor(milliseconds / 1000)
        const minutes = Math.floor(totalSeconds / 60)
        const seconds = totalSeconds % 60
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
    }

    seek(event) {
        if (!event || !event.clientX) return

        const rect = this.progressBar.parentElement.getBoundingClientRect()
        const clickPosition = event.clientX - rect.left
        const percentage = clickPosition / rect.width
        const seekIndex = Math.floor(this.images.length * percentage)

        const wasPlaying = !this.isPaused()
        this.pause(false) // Pause it first
        this.currentIndex = seekIndex > 0 ? Math.min(seekIndex, this.images.length - 1) : 0
        this.displayImage(this.images[this.currentIndex])
        this.updatePlayTime()
        if (wasPlaying) {
            this.play()
        }
    }

    clearPlayInterval() {
        if (this.playInterval) {
            clearInterval(this.playInterval)
            this.playInterval = null
        }
    }

    play(from = null) {
        this.clearPlayInterval()

        if (this.playInterval) {
            clearInterval(this.playInterval)
        }

        if (typeof from === 'number' && from <= 1) {
            this.currentIndex = Math.floor(this.images.length * from)
        } else if (typeof from === 'number') {
            this.currentIndex = from
        }

        this.lastPlayTimestamp = Date.now()
        this.playInterval = setInterval(() => {
            if (this.getCurrentTime() >= this.images.length * this.displayTime) {
                this.pause()
                this.trigger('finish')
                this.currentIndex = 0
                return
            }

            const timeElapsed = Date.now() - this.lastPlayTimestamp
            if (timeElapsed >= this.displayTime) {
                this.currentIndex++
                this.displayImage(this.images[this.currentIndex])
                this.lastPlayTimestamp = Date.now()
                const currentMetadata = this.appsStartingFrame.find((appFrame) => this.currentIndex < appFrame.startingFrame)
                this.displayAppName(currentMetadata)
            }

            this.updatePlayTime()
            // this.container.classList.remove('active')
        }, 1000)

        this.trigger('play')
    }

    pause(updateIcons = true) {
        if (this.playInterval) {
            clearInterval(this.playInterval)
            this.playInterval = null
            if (updateIcons) {
                this.container.classList.add('active')
                this.centerPlayPauseButton.innerHTML = '<i class="material-icons">play_arrow</i>'
                // this.toolbarPlayButton.innerHTML = '<i class="material-icons">play_arrow</i>'
            }
            this.trigger('pause')
        }
    }

    displayAppName(app, force = false) {
        if (!app || (!force && this.appNameLabel.dataset.package === app.package)) return
        this.appNameLabel.dataset.package = app.package

        //this.appNameLabel.style.backgroundImage = `url(${app.icon})`;
        this.appNameLabel.classList.remove('fadeInUp')
        this.appNameLabel.classList.add('fadeOutDown')
        const defaultIcon = './android.robot.jpeg'
        setTimeout(() => {
            this.appNameLabel.classList.remove('fadeOutDown')
            this.appNameLabel.innerHTML = `<img src="${app.icon}" onerror="this.src='${defaultIcon}'" alt="${app.name}"> ${app.name}`
            this.appNameLabel.classList.add('fadeInUp')
        }, 500)

        const currentApp = document.querySelector('.apps_timeline .app_item.active')
        if (currentApp) currentApp.classList.remove('active')
        const appItem = document.getElementById('frame' + app.startingFrame)
        if (appItem) {
            appItem.classList.add('active')
            appItem.scrollIntoView({ behavior: 'smooth', inline: 'center' })
        }
    }

    getCurrentTime() {
        return this.currentIndex * this.displayTime + ((Date.now() - this.lastPlayTimestamp) % this.displayTime)
    }

    getPlayPercentage() {
        if (!this.images.length) return 0
        return this.currentIndex / this.images.length
    }

    on(eventName, callback) {
        if (!this.listeners[eventName]) {
            this.listeners[eventName] = []
        }
        this.listeners[eventName].push(callback)
    }

    trigger(eventName) {
        if (this.listeners[eventName]) {
            this.listeners[eventName].forEach((callback) => callback())
        }
    }

    handleKeydown(event) {
        switch (event.keyCode) {
            case 39: // Right arrow
                this.nextImage()
                break
            case 37: // Left arrow
                this.previousImage()
                break
            case 32: // Spacebar
                this.togglePlayPause()
                event.preventDefault() // To prevent default scrolling behavior
                break
            case 27: // Escape
                this.hide()
                break
            // Add more cases if you want to handle other keys
        }
    }

    nextImage() {
        if (this.currentIndex < this.images.length - 1) {
            this.currentIndex++
            this.displayImage(this.images[this.currentIndex])
            this.updatePlayTime()
        }
    }

    previousImage() {
        if (this.currentIndex > 0) {
            this.currentIndex--
            this.displayImage(this.images[this.currentIndex])
            this.updatePlayTime()
        }
    }

    isLive(e) {
        if (!e) {
            return this.container.classList.contains('live')
        }

        console.log('isLive', this.container, e)
        if (e) this.container.classList.add('live')
        else this.container.classList.remove('live')
    }

    close() {
        this.hide()
    }

    hide() {
        // Remove keydown event listener
        document.removeEventListener('keydown', this.keydownHandler)
        this.clearPlayInterval()
        this.container.classList.remove('zoomIn')
        this.container.classList.add('zoomOut')
        setTimeout(() => {
            this.container.remove()
            //document.body.style.overflow = '';
        }, 500)

        if (this.onclose) this.onclose(this.id)
        this.enableUserScaling()
        if (this.AlbumView) this.AlbumView.close()

        // Add any other cleanup logic you might need here
        if (history.state.page && history.state.page == 3) {
            history.back()
        }
    }

    initializeZoomEventListeners() {
        this.allowZoom = true
        this.zoomLevel = 1 // Initialize zoom level to 1 (no zoom)
        this.minZoom = 0 // Minimum zoom level
        this.maxZoom = 3 // Maximum zoom level
        this.startDistance = 0 // Starting distance between two touch points

        // Attach mouse wheel event listener
        this.container.addEventListener('wheel', (e) => {
            if (!this.allowZoom || window.innerHeight - e.y < 126) return
            if (e.deltaY > 0) {
                // Zoom out
                this.zoomLevel = Math.max(this.zoomLevel - 0.1, this.minZoom)
            } else {
                // Zoom in
                this.zoomLevel = Math.min(this.zoomLevel + 0.1, this.maxZoom)
            }
            this.applyZoom()
            e.preventDefault()
        })

        // Attach touch event listeners for pinch zooming
        this.container.addEventListener('touchstart', (e) => {
            if (e.touches.length === 2) {
                this.startDistance = this.getDistanceBetweenTouches(e)
            }
        })

        this.container.addEventListener('touchmove', (e) => {
            if (!this.allowZoom) return
            if (e.touches.length === 2) {
                const currentDistance = this.getDistanceBetweenTouches(e)
                if (currentDistance > this.startDistance) {
                    // Zoom in
                    this.zoomLevel += 0.025
                } else if (currentDistance < this.startDistance) {
                    // Zoom out
                    this.zoomLevel -= 0.025
                }
                this.zoomLevel = Math.min(Math.max(this.zoomLevel, this.minZoom), this.maxZoom) // Clamp zoom level
                this.applyZoom()
                this.startDistance = currentDistance // Update starting distance for next move
            }
        })
    }

    getDistanceBetweenTouches(event) {
        const touch1 = event.touches[0]
        const touch2 = event.touches[1]
        const dx = touch1.pageX - touch2.pageX
        const dy = touch1.pageY - touch2.pageY
        return Math.sqrt(dx * dx + dy * dy) // Distance formula
    }

    applyZoom() {
        if (this.zoomLevel > 0.98 && this.zoomLevel < 1.02) {
            this.zoomLevel = 1
        }

        if (this.zoomLevel === 1) {
            this.allowZoom = false
            setTimeout(() => {
                this.allowZoom = true
            }, 800) // Re-enable zooming after x second
        }

        this.thumbnail.style.transform = `scale(${this.zoomLevel})`

        // document.querySelector('.first-screen').style.width = `${this.zoomLevel * 20}%`
        // if (this.zoomLevel <= 0.5) {
        //     document.querySelector('.first-screen').style.width = `${10}%`
        // }
    }

    disableUserScaling() {
        this.viewportMetaTag.content = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0, viewport-fit=cover'
    }

    enableUserScaling() {
        this.viewportMetaTag.content = 'width=device-width, initial-scale=1, maximum-scale=5, user-scalable=1, viewport-fit=cover'
    }

    setTitle(data) {
        if (!data) return
        this.title.querySelector('.timeago').innerHTML = timeAgo(data.time)
        this.title.querySelector('.device-location span').innerHTML = data.location
    }

    showAlbumView() {
        this.pause(false)
        this.albumView = new albumView({ frames: this.frames, data: this.data })
    }
}

module.exports = ImagePlayer
